
<div class="container_herramienta" *ngIf="dataActual">
    <!-- Se muestra si existe imagen -->
    <img class="img_toAnimate" *ngIf="dataActual?.imagen" [src]="dataActual.imagen" alt="Imagen promoción">
    
    <div class="alinearIzq">
        <h1 class="title-section">{{ dataActual.titulo }}</h1>
          <!-- Se muestra si existe imagen -->
        <img class="img_forMobil" *ngIf="dataActual?.imagen" [src]="dataActual.imagen" alt="Imagen promoción">
        <div class="descripcion_cont">
            <p *ngIf="dataActual?.descripcion" [innerText]="dataActual.descripcion" style="white-space: pre-line;"></p>
            <!-- Se muestra si existen beneficios -->
             <div  *ngIf="dataActual?.beneficios?.length > 0">
                <h3>Beneficios</h3>
                <ul>
                    <li *ngFor="let beneficio of dataActual.beneficios"> {{ beneficio }}</li>
                </ul>
            </div>

            <h3>Términos y condiciones</h3>
            <ul class="terminos-lista">
                <li *ngFor="let termino of dataActual.terminos" [innerHTML]="termino"></li>
              </ul>

              <div class="content_button" *ngIf="dataActual?.boton?.length > 0">
                <div class="buttonAction" routerLink="/guias-web">Comprar ahora</div>
            </div>
        </div>
    </div>
  <!-- Se muestra si no existen datos -->
    <div *ngIf="!dataActual">
        <p>No hay información disponible para esta promoción.</p>
    </div>